import * as React from "react";
import { forwardRef, memo } from "react";
const SvgJp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#fff", height: 600, width: 900 }), /* @__PURE__ */ React.createElement("circle", { fill: "#bc002d", cx: 450, cy: 300, r: 180 }));
const ForwardRef = forwardRef(SvgJp);
const Memo = memo(ForwardRef);
export default Memo;
